import { ShapeLogo } from '@shape-ds/components';
import React from 'react';
import './style.scss';

const PdfFooter: React.FC = () => {
  return (
    <footer className="pdf-footer">
      <ShapeLogo height="20px" />
    </footer>
  );
};

export default PdfFooter;
